module.exports = __webpack_public_path__ + "img/sepah.2baaa9a8.png";